<app-view-tour-pages gaCategory="View Tutorial">

    <app-view-tour-page>

        <app-view-tour-slide title="Rotate" [trigger]="triggers.CameraRotate">
            Click and drag the model to change the viewing angle.          
        </app-view-tour-slide>

        <app-view-tour-slide>
            <div class="flex justify-start items-center">
                <div>
                    <app-view-tour-success [inline]="true" class="mr-2"></app-view-tour-success>
                    <strong class="text-semibold">Tip:</strong> You can also use the arrow keys <app-view-tour-tip-button icon="caret-up" label="up"></app-view-tour-tip-button> <app-view-tour-tip-button icon="caret-down" label="down"></app-view-tour-tip-button> <app-view-tour-tip-button icon="caret-left" label="left"></app-view-tour-tip-button> <app-view-tour-tip-button icon="caret-right" label="right"></app-view-tour-tip-button> to rotate.
                </div>
            </div>

        </app-view-tour-slide>

    </app-view-tour-page>

    <app-view-tour-page>

        <app-view-tour-slide
            title="Zoom"
            [trigger]="triggers.CameraZoom"
            [ngSwitch]="captureScroll$ | async">
           
            <ng-container *ngSwitchCase="false">
                Hold the control key and scroll up and down to zoom in or out.
            </ng-container>

            <ng-container *ngSwitchDefault>
                Scroll up and down to zoom in or out.
            </ng-container>

        </app-view-tour-slide>

        <app-view-tour-slide>
            <div class="flex justify-start items-center">
                <div>
                    <app-view-tour-success [inline]="true" class="mr-2"></app-view-tour-success>
                    <strong class="text-semibold">Tip:</strong> You can also use <app-view-tour-tip-button label="+"></app-view-tour-tip-button> to zoom in and <app-view-tour-tip-button label="-"></app-view-tour-tip-button> to zoom out.
                </div>
            </div>
        </app-view-tour-slide>

    </app-view-tour-page>

    <app-view-tour-page>

        <app-view-tour-slide title="Pan" [trigger]="triggers.CameraPan">
            Hold the shift key and drag to move the model's position.
        </app-view-tour-slide>

        <app-view-tour-slide>
            <div class="flex justify-start items-center">
                <div>
                    <app-view-tour-success [inline]="true" class="mr-2"></app-view-tour-success>
                    <strong class="text-semibold">Tip:</strong> You can also use the <app-view-tour-tip-button label="W"></app-view-tour-tip-button> <app-view-tour-tip-button label="A"></app-view-tour-tip-button> <app-view-tour-tip-button label="S"></app-view-tour-tip-button> <app-view-tour-tip-button label="D"></app-view-tour-tip-button> keys to pan.
                </div>
            </div>
        </app-view-tour-slide>

    </app-view-tour-page>

    <app-view-tour-page>

        <app-view-tour-slide title="Explore the Anatomy" [trigger]="triggers.NodeSelection">
            Click on an individual part of the model to highlight anatomy.
        </app-view-tour-slide>

        <app-view-tour-slide>
            <div class="flex justify-start items-center">
                <div>
                    <app-view-tour-success [inline]="true" class="mr-2"></app-view-tour-success>
                    <strong class="text-semibold">Tip:</strong> Double-click to zoom in on specific structures.
                </div>
            </div>
        </app-view-tour-slide>

    </app-view-tour-page>

    <app-view-tour-page>


        <app-view-tour-slide image="assets/images/tutorial/tutorial-toolbar@3x.png">
            Use the toolbar to navigate through the 3D experience, launch deeper exploration tools, and relaunch this tutorial.

            <div class="flex flex-column items-center justify-center" slide-footer>
                <button 
                    gaEvent
                    gaAction="Clicked Start Exploring"
                    app-view-rounded-button
                    buttonType="solid"
                    label="Start Exploring!"
                    aria-label="Start Exploring"             
                    class="mt-4"
                    (click)="handleStartClick()">
                </button>         
            </div>
        </app-view-tour-slide>

    </app-view-tour-page>

</app-view-tour-pages>